import { Controller } from '@hotwired/stimulus'
import { dispatchCustomEvent } from '../../../helpers/custom_events_helper'

// TODO: Make this keyboard accessible
export default class extends Controller {
  static targets = ['card']
  static values = {
    cycleId: Number,
    snapshotId: Number
  }

  connect() {
    this.updateActiveCardFromUrl()
  }

  updateActiveCardFromUrl() {
    // Check URL for snapshot_id and activate the corresponding card
    const url = new URL(window.location.href)
    const snapshotId = url.searchParams.get('snapshot_id')

    if (snapshotId) {
      // Find the card with this snapshot_id
      const matchingCard = this.cardTargets.find(card => {
        const cardSnapshotId = card.dataset['reportingCycles-HistoryTimelineSnapshotIdParam']
        return cardSnapshotId === snapshotId
      })

      if (matchingCard) {
        this.setActiveCard(matchingCard)
      }
    } else {
      // No snapshot_id, activate the "Current" card
      const currentCard = this.cardTargets.find(card => card.dataset.type === 'current')
      if (currentCard) {
        this.setActiveCard(currentCard)
      }
    }
  }

  selectCard(event) {
    const clickedCard = event.currentTarget

    // Only allow clicking on cards with data-clickable="true"
    if (clickedCard.dataset.clickable !== 'true') {
      return
    }

    this.setActiveCard(clickedCard)

    // Get snapshot_id from action params
    const snapshotId = event.params.snapshotId

    // Dispatch event for snapshot manager to handle URL and frame reloading
    dispatchCustomEvent(window, 'reporting-cycle:snapshot-changed', {
      detail: { snapshotId: snapshotId || '' }
    })
  }

  setActiveCard(activeCard) {
    // Remove active class from all clickable cards
    this.cardTargets.forEach(card => {
      if (card.dataset.clickable !== 'true') {
        return
      }
      card.classList.remove('history-timeline__card--active')
      card.classList.add('history-timeline__card--inactive')
    })

    // Add active class to the specified card and remove inactive
    activeCard.classList.remove('history-timeline__card--inactive')
    activeCard.classList.add('history-timeline__card--active')
  }
}
